<div *ngIf="success" class="alert alert-success alert-dismissible fade show">
  {{ successMessage }}
  <button (click)="success = false" aria-label="Close" class="close" type="button">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div *ngIf="filteredBwAvailabilities">
  <div class="row">
    <div class="col-12">
      <p-panel [toggleable]="true">
        <ng-template pTemplate="header">
          <span class="filter-title p-panel-title"><i class="fa fa-search"></i>Filter</span>
        </ng-template>
        <div class="row">
          <div class="form-group col-3">
            <p-floatLabel>
              <p-dropdown [(ngModel)]="filterParams.tPop" (ngModelChange)="filter()" [filter]="true"
                          [options]="possibleTPopsOptions" [showClear]="true" inputId="tPop"></p-dropdown>
              <label for="tPop" style="left:0;">Technical pop</label>
            </p-floatLabel>
          </div>
          <div class="form-group col-3">
            <p-floatLabel>
              <p-dropdown [(ngModel)]="filterParams.cPop" (ngModelChange)="filter()" [filter]="true"
                          [options]="possibleCPopsOptions" [showClear]="true" inputId="cPop" type="text"></p-dropdown>
              <label for="cPop" style="left:0;">Commercial pop</label>
            </p-floatLabel>
          </div>
          <div class="form-group col-2">
            <p-floatLabel>
              <input [(ngModel)]="filterParams.product" (ngModelChange)="filter()" class="form-control"
                     name="product" id="product" type="text" pInputText>
              <label for="product">Product</label>
            </p-floatLabel>
          </div>
          <div class="form-group col-2">
            <p-floatLabel>
              <input [(ngModel)]="filterParams.options" (ngModelChange)="filter()" class="form-control"
                     name="options" id="options" type="text" pInputText>
              <label for="options">Options</label>
            </p-floatLabel>
          </div>
          <div class="form-group col-2 pt-4">
            <div class="col-9">
              <div class="margin-checkbox">
                <p-checkbox [(ngModel)]="filterParams.injection" (ngModelChange)="filter()" binary="true"
                            label="Injection" name="encrypted"></p-checkbox>
              </div>
              <div class="margin-checkbox">
                <p-checkbox [(ngModel)]="filterParams.reception" (ngModelChange)="filter()"
                            binary="true" label="Reception" name="non-encrypted"></p-checkbox>
              </div>
            </div>
          </div>
        </div>
      </p-panel>
    </div>
  </div>

  <p-table [columns]="cols" [rowHover]="true" [tableStyle]="{'table-layout':'auto'}"
           [value]="filteredBwAvailabilities"
           id="qrd-multicast-table">
    <ng-template pTemplate="header">
      <tr>
        <th *ngFor="let col of cols" [pSortableColumnDisabled]="col.sortable" [pSortableColumn]="col.field">
          <ng-container *ngIf="col.header === 'tPops'">
            {{ tPopsHeader }}
          </ng-container>
          <ng-container *ngIf="col.header !== 'tPops'">
            {{ col.header }}
          </ng-container>
          <p-sortIcon *ngIf="!col.sortDisabled" [field]="col.field"></p-sortIcon>
          <i *ngIf="col.field === 'publicDescription'" class="fa fa-question-circle pull-right"
             pTooltip="This is a public description. It can be viewed by clients."
             style="color: grey;"></i>
        </th>
      </tr>
    </ng-template>
    <ng-template let-bwAvailability pTemplate="body">
      <tr *ngFor="let product of bwAvailability.products; index as i">
        <td *ngIf="i === 0" [attr.rowspan]="bwAvailability.products.length"
            style="vertical-align: top">{{ bwAvailability.cPop }}
          / <span
            [pTooltip]="technicalPopService.getCageTooltip(bwAvailability.technicalPop)">{{ bwAvailability.technicalPop }} </span>
          <i class="fa fa-question-circle" pTooltip="{{bwAvailability.marketDataId}}" style="color: grey;"></i></td>
        <td style="vertical-align: top">{{ product['productName'] }}</td>
        <td style="vertical-align: top">{{ product['method'] }}</td>
        <td style="vertical-align: top">{{ product['options'] }}</td>
        <td style="vertical-align: top; max-width: 200px;">
          <span *ngFor="let pop of product['associatedTPops']; let isLast=last">
              <span [pTooltip]="technicalPopService.getCageTooltip(pop.technical_id)">{{ pop.technical_id }} </span>
            <i *ngIf="pop.is_lowest_latency" class="fa fa-fw fa-check-circle"
               pTooltip="Checked if {{pop.technical_id}} has lowest latency for Bandwidth service"
               style="color:#0062cc"></i>{{ isLast ? '' : ', ' }}
          </span>
        </td>
        <td *roles="['ROLE_MCKAY']">
          <textarea (focusin)="product.textAriaRows = 4" (focusout)="changePublicDescription(product)"
                    (keyup.enter)="changePublicDescription(product)"
                    [(ngModel)]="product.newPublicDescription"
                    [rows]="product.textAriaRows" class="form-control"
                    id="publicDescription"
                    name="publicDescription">
          </textarea>
        </td>
        <td *roles="['ROLE_CLIENT']"> {{ product['publicDescription'] }}</td>
        <td *roles="['ROLE_MCKAY']" style="vertical-align: top">{{ product['updatedBy'] }}</td>
        <td *roles="['ROLE_MCKAY']"
            style="vertical-align: top; min-width: 185px !important;">{{ product['updatedAt'] }}
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
